export default function Privacy() {
  const style = `
    @import url('https://fonts.googleapis.com/css2?family=Fraunces:ital,wght@0,900;1,900&family=Plus+Jakarta+Sans:wght@400;500;600;700&display=swap');
    *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
    body { font-family: 'Plus Jakarta Sans', sans-serif; background: #FAF7F2; color: #1E1040; }
    .legal-nav { background: #fff; border-bottom: 1px solid #EDE9E3; padding: 16px 48px; display: flex; align-items: center; justify-content: space-between; }
    .legal-logo { font-family: 'Fraunces', serif; font-weight: 900; font-size: 22px; color: #1E1040; text-decoration: none; }
    .legal-logo span { color: #8B5CF6; font-style: italic; }
    .legal-wrap { max-width: 760px; margin: 0 auto; padding: 60px 48px; }
    .legal-eyebrow { font-size: 11px; font-weight: 700; letter-spacing: 0.14em; text-transform: uppercase; color: #8B5CF6; margin-bottom: 12px; }
    .legal-title { font-family: 'Fraunces', serif; font-weight: 900; font-size: 42px; color: #1E1040; margin-bottom: 8px; line-height: 1.1; }
    .legal-date { font-size: 13px; color: #9CA3AF; margin-bottom: 48px; }
    .legal-intro { font-size: 16px; color: #374151; line-height: 1.8; margin-bottom: 40px; padding: 24px; background: rgba(139,92,246,0.04); border: 1px solid rgba(139,92,246,0.1); border-radius: 14px; }
    .legal-section { margin-bottom: 36px; }
    .legal-section h2 { font-family: 'Fraunces', serif; font-weight: 900; font-size: 22px; color: #1E1040; margin-bottom: 14px; }
    .legal-section p { font-size: 15px; color: #374151; line-height: 1.8; margin-bottom: 12px; }
    .legal-section ul { list-style: none; margin: 0 0 12px 0; display: flex; flex-direction: column; gap: 8px; }
    .legal-section ul li { font-size: 15px; color: #374151; line-height: 1.6; padding-left: 20px; position: relative; }
    .legal-section ul li::before { content: '·'; position: absolute; left: 0; color: #8B5CF6; font-weight: 700; }
    .legal-section a { color: #8B5CF6; text-decoration: none; }
    .legal-section a:hover { text-decoration: underline; }
    .legal-footer { margin-top: 60px; padding-top: 32px; border-top: 1px solid #EDE9E3; display: flex; gap: 24px; flex-wrap: wrap; }
    .legal-footer a { font-size: 13px; color: #9CA3AF; text-decoration: none; transition: color 0.2s; }
    .legal-footer a:hover { color: #8B5CF6; }
    @media(max-width:640px){ .legal-wrap { padding: 40px 24px; } .legal-nav { padding: 16px 24px; } }
  `;

  return (
    <>
      <style>{style}</style>
      <nav className="legal-nav">
        <a href="/" className="legal-logo">Merq<span>Legacy</span></a>
        <a href="mailto:hello@getmerq.com" style={{fontSize:13,color:'#9CA3AF',textDecoration:'none'}}>hello@getmerq.com</a>
      </nav>
      <div className="legal-wrap">
        <div className="legal-eyebrow">Legal</div>
        <h1 className="legal-title">Privacy Policy</h1>
        <div className="legal-date">Last updated: April 10, 2026</div>

        <div className="legal-intro">
          We wrote this in plain English on purpose. Your family's information is sacred — we treat it that way. We will never sell your data, share it with advertisers, or use it for anything other than running this service.
        </div>

        <div className="legal-section">
          <h2>Who We Are</h2>
          <p>Merq Legacy is a family estate organizer operated by <strong>Merq Software</strong>, a sole proprietorship based in Texas, United States. References to "we," "us," or "our" refer to Merq Software. References to "you" refer to the person using the application.</p>
        </div>

        <div className="legal-section">
          <h2>What Information We Collect</h2>
          <p>We collect only what's necessary to provide the service:</p>
          <ul>
            <li>Your email address and name when you create an account</li>
            <li>The information you voluntarily enter into your vault (contacts, accounts, assets, documents, wishes)</li>
            <li>Names and email addresses of Vault Guardians you designate</li>
            <li>Payment information processed securely by Paddle (we never see or store your full card details)</li>
            <li>Basic usage data to improve the product (pages visited, features used)</li>
          </ul>
        </div>

        <div className="legal-section">
          <h2>What We Do Not Collect</h2>
          <ul>
            <li>We never connect to your bank accounts or financial institutions</li>
            <li>We never store actual passwords — only hints if you choose to enter them</li>
            <li>We never collect your Social Security Number or government ID numbers</li>
            <li>We never track you across other websites</li>
          </ul>
        </div>

        <div className="legal-section">
          <h2>How We Use Your Information</h2>
          <ul>
            <li>To operate and provide the Merq Legacy service</li>
            <li>To send Vault Guardian invitation emails on your behalf</li>
            <li>To process your subscription through Paddle</li>
            <li>To send essential service communications (security alerts, subscription updates)</li>
            <li>To improve the product based on aggregate usage patterns</li>
          </ul>
        </div>

        <div className="legal-section">
          <h2>Who We Share Your Information With</h2>
          <p>We share your information only with:</p>
          <ul>
            <li><strong>Supabase</strong> — our database and storage provider, used to securely store your vault data</li>
            <li><strong>Paddle</strong> — our payment processor, who handles all subscription billing</li>
            <li>No one else. We do not sell your data. We do not share it with advertisers. Ever.</li>
          </ul>
        </div>

        <div className="legal-section">
          <h2>Your Vault Data</h2>
          <p>The information you store in your vault — contacts, accounts, assets, documents, and final wishes — belongs entirely to you. We store it securely to provide the service. We do not access, read, or analyze the contents of your vault except when technically required to provide support at your explicit request.</p>
          <p>Your uploaded documents are stored in a private, encrypted storage bucket. They are not publicly accessible.</p>
        </div>

        <div className="legal-section">
          <h2>Vault Guardian Access</h2>
          <p>Vault Guardians you designate will receive an invitation email with their role explained. They cannot access your vault contents unless a formal access request is made and approved by the minimum required number of Guardians. You can remove or change Vault Guardians at any time.</p>
        </div>

        <div className="legal-section">
          <h2>Data Retention</h2>
          <p>We retain your data for as long as your account is active. If you cancel your subscription, your vault data remains accessible until the end of your billing period. If you request account deletion, we will delete your data within 30 days, except where required by law to retain it.</p>
        </div>

        <div className="legal-section">
          <h2>Your Rights</h2>
          <ul>
            <li>You can export or delete your data at any time by contacting us</li>
            <li>You can update your account information from within the app</li>
            <li>You can request a copy of the personal data we hold about you</li>
            <li>If you are in the EU or UK, you have additional rights under GDPR</li>
          </ul>
        </div>

        <div className="legal-section">
          <h2>Security</h2>
          <p>We use industry-standard security practices including encrypted connections (HTTPS), secure database storage via Supabase, and private document storage. No security system is perfect — if you believe your account has been compromised, contact us immediately at <a href="mailto:hello@getmerq.com">hello@getmerq.com</a>.</p>
        </div>

        <div className="legal-section">
          <h2>Changes to This Policy</h2>
          <p>We may update this Privacy Policy from time to time. We will notify you of significant changes by email. Continued use of the service after changes constitutes acceptance of the updated policy.</p>
        </div>

        <div className="legal-section">
          <h2>Contact Us</h2>
          <p>Questions about this Privacy Policy? We're real people and we'll respond.</p>
          <p><a href="mailto:hello@getmerq.com">hello@getmerq.com</a><br />Merq Software · Texas, United States</p>
        </div>

        <div className="legal-footer">
          <a href="/">Home</a>
          <a href="/privacy">Privacy Policy</a>
          <a href="/terms">Terms of Service</a>
          <a href="/refund">Refund Policy</a>
          <a href="mailto:hello@getmerq.com">Contact</a>
        </div>
      </div>
    </>
  );
}
